module.exports = "/images/Bumper boat.svg?4465274500fb2ef0754a84bbf3082256";